export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6469.ccd8c2ef.jpg";